import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'categoryParser'
})
export class CategoryParserPipe implements PipeTransform {
  transform(value: any): string[] {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') return value.split(',').map(v => v.trim());
    return [];
  }
}
